var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { fetchAgencyPrefixById, deleteAgencyPrefix, } from "../api/agencyPrefixesService";
import { useDetailParam } from "../utils/detailParam";
import { useModal } from "../utils/useModal";
import { useApiAction } from "../utils/useApiAction";
import { AgencyErrorTypes } from "../routes/agency-worker/AgencyErrorTypes";
import { getErrorCode } from "../utils/getErrorCode";
import { getAgencyMessageId } from "../utils/getAgencyMessageId";
export var useAgencyPrefixActions = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var kyRef = useRef(ky);
    useEffect(function () {
        kyRef.current = ky;
    }, [ky]);
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var updateDetailParamRef = useRef(updateDetailParam);
    useEffect(function () {
        updateDetailParamRef.current = updateDetailParam;
    }, [updateDetailParam]);
    var _b = useState(null), selectedAgencyPrefix = _b[0], setSelectedAgencyPrefix = _b[1];
    var _c = useModal(), isOpen = _c.isOpen, message = _c.message, action = _c.action, openModal = _c.openModal, closeModal = _c.closeModal;
    var performAction = useApiAction().performAction;
    var _d = useState(false), errorOpen = _d[0], setErrorOpen = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    useEffect(function () {
        var abortController = new AbortController();
        if (!detailId) {
            setSelectedAgencyPrefix(function (prev) { return (prev ? null : prev); });
            return undefined;
        }
        fetchAgencyPrefixById(kyRef.current, detailId)
            .then(function (prefix) {
            if (abortController.signal.aborted)
                return;
            setSelectedAgencyPrefix(function (prev) {
                return (prev === null || prev === void 0 ? void 0 : prev.id) === (prefix === null || prefix === void 0 ? void 0 : prefix.id) ? prev : (prefix !== null && prefix !== void 0 ? prefix : null);
            });
        })
            .catch(function () {
            if (abortController.signal.aborted)
                return;
            setSelectedAgencyPrefix(null);
            updateDetailParamRef.current(null);
        });
        return function () {
            abortController.abort();
        };
    }, [detailId]);
    var handleRowClick = function (item) {
        updateDetailParamRef.current(item.id);
        setSelectedAgencyPrefix(item);
    };
    var handleCloseDetail = function () {
        setSelectedAgencyPrefix(null);
        updateDetailParamRef.current(null);
    };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, code, messageId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, performAction({
                            apiCall: function () { return deleteAgencyPrefix(kyRef.current, id); },
                            queryKey: "agency-prefixes",
                            errorMsg: formatMessage({
                                id: "ui-br-agency.agency-prefix.error.delete",
                            }),
                            onSuccess: function () {
                                setSelectedAgencyPrefix(null);
                                updateDetailParamRef.current(null);
                                closeModal();
                            },
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    return [4 /*yield*/, getErrorCode(error_1)];
                case 3:
                    code = _a.sent();
                    messageId = code === AgencyErrorTypes.CHILDREN
                        ? getAgencyMessageId(AgencyErrorTypes.CHILDREN)
                        : "ui-br-agency.agency-prefix.submit";
                    setErrorMessage(formatMessage({ id: messageId }));
                    setErrorOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openConfirm = function (item) {
        openModal(formatMessage({ id: "ui-br-agency.agency-prefix.delete.confirm" }, { prefix: item.value }), function () { return handleDelete(item.id); });
    };
    var confirmDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!action) return [3 /*break*/, 2];
                    return [4 /*yield*/, action()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        selectedAgencyPrefix: selectedAgencyPrefix,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
        isOpen: isOpen,
        message: message,
        openConfirm: openConfirm,
        closeModal: closeModal,
        confirmDelete: confirmDelete,
        errorOpen: errorOpen,
        errorMessage: errorMessage,
        setErrorOpen: setErrorOpen,
    };
};
